import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

const DOCS_ICON_LIST: any = {
  PDF: 'assets/icons/DOCUMENT_TYPE_PDF.svg',
  DOC: 'assets/icons/DOCUMENT_TYPE_DOC.svg',
  DOCX: 'assets/icons/DOCUMENT_TYPE_DOC.svg',
  XLS: 'assets/icons/DOCUMENT_TYPE_XLS.svg',
  XLSX: 'assets/icons/DOCUMENT_TYPE_XLS.svg',
  PPT: 'assets/icons/DOCUMENT_TYPE_PPT.svg',
  PPTX: 'assets/icons/DOCUMENT_TYPE_PPT.svg',
  RAR: 'assets/icons/DOCUMENT_TYPE_ZIP.svg',
  ZIP: 'assets/icons/DOCUMENT_TYPE_ZIP.svg',
  HTML: 'assets/icons/DOCUMENT_TYPE_HTML.svg',
  TXT: 'assets/icons/DOCUMENT_TYPE_TXT.svg',
  JPG: 'assets/icons/DOCUMENT_TYPE_JPG.svg',
  PNG: 'assets/icons/DOCUMENT_TYPE_PNG.svg',
  SVG: 'assets/icons/DOCUMENT_TYPE_SVG.svg',
  AI: 'assets/icons/DOCUMENT_TYPE_AI.svg',
};

@Component({
  selector: 'app-add-document-modal',
  templateUrl: './add-document-modal.component.html',
  styleUrls: ['./add-document-modal.component.scss'],
})
export class AddDocumentModalComponent implements OnInit {
  @Input() filesTypes: string[] = [];
  // Options (documents de réservation) ; valeurs par défaut = comportement des commandes.
  @Input() accept: string = '';
  @Input() maxSize: number | null = null;
  @Input() typeLabels: { [type: string]: string } | null = null;
  @Input() requireType: boolean = false;

  fileError: string | null = null;

  @ViewChild('inputFile') inputFileRef!: ElementRef;

  doc: any = {
    type: '',
    description: '',
    mimetype: '',
    fileName: '',
    base64: '',
  };

  constructor(readonly activeModal: NgbActiveModal) {}

  ngOnInit(): void {}

  addFile() {
    this.inputFileRef.nativeElement.click();
  }

  async changeListenerDoc(event: any): Promise<void> {
    try {
      let file = event.target.files[0];
      this.fileError = null;
      if (!file) return;
      if (this.maxSize && file.size > this.maxSize) {
        this.fileError = `Fichier trop volumineux (maximum ${Math.round(this.maxSize / 1024 / 1024)} Mo)`;
        event.target.value = '';
        return;
      }
      let originData = await this.fileToBase64(file);

      this.doc.mimetype = file.type;
      this.doc.fileName = file.name;
      this.doc.base64 = originData;
    } catch (error) {
      console.error(error);
    }
  }

  public async fileToBase64(file: any): Promise<any> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = async (_event) => {
        resolve(reader.result);
      };
      reader.onerror = async (_event) => {
        reject(reader.error);
      };

      reader.readAsDataURL(file);
    });
  }

  get canSave(): boolean {
    if (this.requireType) {
      return !!this.doc.fileName && !!this.doc.type;
    }
    return !!this.doc.fileName || !!this.doc.type;
  }

  getFileExt(): string {
    if (this.doc.fileName) {
      let tabExt = this.doc.fileName.split('.');
      let ext = String(tabExt[tabExt.length - 1]).toUpperCase() || 'PDF';
      return DOCS_ICON_LIST[ext];
    } else {
      return '';
    }
  }

  save() {
    this.activeModal.close(this.doc);
  }
}
